import { Extension } from '@tiptap/core'
import { Subscript as TiptapSubscript } from '@tiptap/extension-subscript'
import { Superscript as TiptapSuperscript } from '@tiptap/extension-superscript'
import { SubSuperscriptActionButton } from '@/tiptap/extensions/components/ActionButton'

// NOTE: This wraps both Subscript and Superscript into one combined extension,
// mirroring the TS version's behavior. It also wires a single ActionButton component
// (you already have a SubscriptActionButton in your components folder).

export const SubAndSuperScript = Extension.create({
  name: 'subAndSuperScript',

  // options: { button, subscript, superscript, ...general }
  addOptions() {
    // We keep the same option shape as the TS original.
    // `button` is a function returning a component config used by your toolbar system.
    return {
      ...(this.parent ? this.parent() : {}),
      // Expect your toolbar system to call button({ editor, extension, t })
      button: ({ editor, extension, t }) => ({
        component: SubSuperscriptActionButton,
        componentProps: { editor, extension, t }
      }),
      // Allow disabling either feature; when set to false, that sub-extension isn't added.
      subscript: undefined,   // or false to disable
      superscript: undefined, // or false to disable
    }
  },

  addExtensions() {
    const extensions = []

    if (this.options.subscript !== false) {
      extensions.push(TiptapSubscript.configure(this.options.subscript))
    }

    if (this.options.superscript !== false) {
      extensions.push(TiptapSuperscript.configure(this.options.superscript))
    }

    return extensions
  }
})

// The toolbar system expects a named export; also export default for convenience.
export default SubAndSuperScript